<template>
	<div class="c-editor-presentation">
		<div class="row" v-if="presentation">
			<div class="col-xs-12  col-sm-6">
				<div v-if="chart && chart.fields.title">
					<div class="inline-block">
						<label for="charttitle">Chart Title</label>
					</div>
					<div class="inline-block">
						<input
						id="charttitle"

						v-if="chart && chart.fields.title"
						:disabled="!(chart.permissions && chart.permissions.can_edit && chart.fields.title.permissions.can_edit)"
						class="st-input st-input--small st-input--text"
						type="text"
						v-model="chartitle">
					</div>
				</div>
			</div>

			<div class="col-xs-12 col-sm-6">
				<v-editorbar :token="presentation.token" :urls="presentation.urls" @save="save"></v-editorbar>
			</div>
		</div>

		<div class="reveal-html">
			<div class="reveal-body">
				<router-view @savefield="savechildfield" class="view"></router-view>
			</div>
		</div>
		<div class="row">
			<div class="col-xs-12" v-if="chart && chart.fields && chart.fields.state && chart.fields.state.permissions && chart.fields.state.permissions.can_edit">
				<div class="inline-block">
					<label for="charttitle">States</label>
				</div>
				<div class="inline-block">
					<MultiSelect
					v-model="stateValue"
					:small="true"
					:options="chart.fields.state.options"
					:defaultValue="stateValue" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>

// Base
import Vue from 'vue';

import forEach from 'lodash/forEach';

import help_rest from '@/helpers/rest';
import MultiSelect from '@/components/MultiSelect';

export default {
	name: 'c-editor-presentation',
	components: {
		MultiSelect
	},
	props: {
		pid: {
			type: String,
			default: ''
		},
		master: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		chartitle: {
		    get () {
		    	if(!this.$route.params.chartid) return  false;
		    	let field = this.$store.getters.getChartField(this.$route.params.chartid, 'title');
		      	return (field ? field.value : false)
		    },
		    set (value) {
		    	if(!this.$route.params.chartid) return  false;
		    	let field = this.$store.getters.getChartField(this.$route.params.chartid, 'title');
		    	if(field) {
		    		field.changed = true;
		    		return field.value = value;
		    	}

		    	return false;
		    }
		},
		chart(){
			return (this.$route.params.chartid ? this.$store.getters.getChartById(this.$route.params.chartid) : false);
		},
		stateValue: {
			get () {
		    	if(!this.$route.params.chartid) return  false;
		    	let field = this.$store.getters.getChartField(this.$route.params.chartid, 'state');
		    	if(!field) return false;
		      	return (typeof field.value == 'string' ? field.value.split(' ') : field.value);
		    },
		    set (value) {
		    	if(!this.$route.params.chartid) return  false;
		    	let field = this.$store.getters.getChartField(this.$route.params.chartid, 'state');
		    	if(field) {
		    		field.changed = true;
		    		return field.value = (typeof value !== 'string' ? value.join(' ') : value);
		    	}

		    	return false;
		    }
		},
		presentation_type() {
			return this.$store.getters.presentation.type;
		},
		presentation(){
			return this.$store.getters.presentation;
		},
	},
	methods: {
		...help_rest,

		getSaveableChart(chart, index){
			const self = this;
			let sachart = {};

			sachart.id = chart.id;

			sachart.position = chart.position;
			sachart.trashed  = chart.trashed;
			sachart.visible  = chart.visible;
			sachart.template = chart.template;

			if(chart.newImage){
				sachart.image = chart.image;
			}

			if(chart.charts){
				sachart.charts = {};
				Object.keys(chart.charts).forEach(function(key, index){
					sachart.charts[chart.charts[key].id] = self.getSaveableChart(chart.charts[key], index);
				});
			}

			sachart.fields = {};
			Object.keys(chart.fields)
			.forEach(function(key){
				if(key == 'background-image' || key == 'background-video') return;
				const field = chart.fields[key];

				if(field.changed){
					sachart.fields[key] = field.value;
				}
			});

			return sachart;
		},

		updateCharts(charts){
			const self = this;
			Object.keys(charts)
			.forEach(function(id){
				const newChart = charts[id];
				if(newChart && newChart.updated){
					let chart, oldId;

					if(newChart.updated.trashed) {
						self.$store.commit('DELETE_CHART', id);
						return;
					}

					if(newChart.updated.id){
						oldId = newChart.updated.id.from;
						chart = self.$store.getters.getChartById(oldId);
						Vue.set(chart, 'id', newChart.updated.id.to);

						console.debug('UPDATE_ID_FOR_CHART', oldId, newChart.updated.id.to)
					} else {
						chart = self.$store.getters.getChartById(id);
					}
					console.log('a', chart);

					if(chart && chart.changed){
						chart.changed = false;
					}

					if(newChart.updated.image){
						chart.newImage = false; // updated
					}

					Object.keys(chart.fields).forEach(function(key){
						if(key == 'background-image' || key == 'background-video') return;
						if(!newChart.updated[key]) return;
						const field = self.$store.getters.getChartField(chart.id, key),
							  upd   = newChart.updated[key];

						field.default = upd.to;	// update default
						field.value = upd.to; // update value
					});

					if(chart) {
						if(oldId){
							if(self.$route.params.chartid == oldId){
								self.$router.push({ params: { chartid: id }});
							}
						}

						if(newChart.charts){
							self.updateCharts(newChart.charts);
						}
					}
				}
			});
		},

		save(){
			var self = this;
			let preUrl, presentation, charts, id;
			let payload = {};

			if(this.presentation_type == 'user') {
				preUrl 		= this.$store.getters.channel.urls.user,
				presentation= this.$store.getters.presentation,
				charts 		= this.$store.getters.charts,
				id 			= presentation.id;
			} else if(this.presentation_type == 'customer') {
				preUrl 		= '/api/v1/customers/:id:',
				presentation= this.$store.getters.presentation,
				charts 		= this.$store.getters.charts,
				id 			= this.$store.getters.edituser.id;
			} else if(this.presentation_type == 'partner') {
				preUrl 		= '/api/v1/partners/:id:',
				presentation= this.$store.getters.presentation,
				charts 		= this.$store.getters.charts,
				id 			= this.$store.getters.edituser.id;
			} else {
				preUrl 		= this.$store.getters.channel.urls.presentation,
				presentation= this.$store.getters.presentation,
				charts 		= this.$store.getters.charts,
				id 			= (this.master ? 'master' : presentation.id);
			}

			payload.id = id;
			payload.charts = {};

			Object.keys(charts).forEach(function(key, index){
				let chart = charts[key];
				payload.charts[chart.id] = self.getSaveableChart(chart, index);
			});

			const url = preUrl.replace(':id:', id);

			this.restpatch(url, payload, 'presentation')
			.then(message => {
				if(message && message.updated && message.updated.charts) {
					self.updateCharts(message.updated.charts);
				} else {
					self.updateCharts(message);
				}
			});
		},

		savechildfield(cid, fieldname, newvalue){
			let chart = this.$store.getters.getChartById(cid);
			if(chart && chart.fields && chart.fields[fieldname]){
				if(chart.fields[fieldname].value !== newvalue){
					chart.fields[fieldname].value = newvalue;
				} else {
					console.error(chart.fields[fieldname].value, newvalue, 'value ist the same?');
				}
			} else if(fieldname == 'title'){
				chart.title = newvalue;
			} else {
				console.error(cid, fieldname, 'dosent exits?');
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/p-editor/c-editor-presentation.vue